<template>
  <div class="header">
    <twobtnPopup
      v-if="openPopup"
      @go="go()"
      @close="openPopup = false"
      msg="페이지 이동시 입력하신 내용이 모두 삭제됩니다."
    ></twobtnPopup>
    <div class="desktop">
      <div
        class="header__title"
        :class="{ 'header__title--active': orderLayoutType == 'form' }"
        @click="moveRouter('form')"
      >
        주문접수
      </div>
      <div class="cart">
        <div
          class="header__title"
          :class="{ 'header__title--active': orderLayoutType == 'purchase' }"
          @click="moveRouter('purchase')"
        >
          장바구니
        </div>
        <div
          class="cart-length"
          :class="{ 'cart-length__active': orderLayoutType == 'purchase' }"
        >
          {{ getCartLength }}
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="order" v-if="orderLayoutType === 'form'">
        <div class="header__title header__title--active">주문접수</div>
        <div>
          <img
            src="@/assets/img/order/ic_cart.png"
            @click="moveRouter('purchase')"
          />
          <div class="cart-length cart-length__active">
            {{ getCartLength }}
          </div>
        </div>
      </div>
      <div class="cart" v-if="orderLayoutType === 'purchase'">
        <div class="header__title header__title--active">장바구니</div>
        <div class="cart-length cart-length__active">
          {{ getCartLength }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import twobtnPopup from "@/components/modal/twobtnPopup/layout";
export default {
  components: {
    twobtnPopup,
  },
  methods: {
    handleMoveCart() {
      this.openPopup = true;
    },
    moveRouter(type) {
      if (type === this.orderLayoutType) return;

      type === "form"
        ? this.$router.push("/orders/form")
        : this.$router.push("/orders/purchase");
    },
  },
  mounted() {
    if (this.$route.path.indexOf("form") === -1) {
      this.orderLayoutType = "purchase";
    } else {
      this.orderLayoutType = "form";
    }
  },
  data() {
    return {
      orderLayoutType: null,
      openPopup: false,
      go: false,
    };
  },
  computed: {
    getCartLength() {
      const orders = this.$store.getters["returnPlacedOrder"]();
      return orders.length;
    },
  },
  name: "OrderHeader",
};
</script>

<style src="./layout.css" scoped></style>
